import { getAuthTokens } from "@/lib/auth";
import { AuthTokens, TokenData } from "@/lib/auth-tokens";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

type AuthStore = {
  tokens: AuthTokens | null;
  tokenData: TokenData | null;
  actions: {
    setTokens: (tokens: AuthTokens) => void;
    init: () => void;
    clearTokens: () => void;
  };
};

// TODO: Use this store
export const authStore = create<AuthStore>()(
  devtools(
    (set, get) => ({
      tokens: null,
      tokenData: null,
      actions: {
        setTokens: (tokens: AuthTokens) => {
          set({ tokens, tokenData: tokens.TokenData });
        },
        // Initialize the store with the tokens from the local storage
        init: () => {
          const { setTokens } = get().actions;
          const tokens = getAuthTokens();
          setTokens(tokens);
        },
        // TODO: Wipe GeneralConfigStore
        clearTokens: () =>
          set({
            tokens: null,
            tokenData: null,
          }),
      },
    }),
    {
      name: "auth-store",
      enabled: !import.meta.env.PROD,
    },
  ),
);

/**
 * Returns the tokens stored in the AuthStore
 */
export const useAuthTokens = () => authStore((state) => state.tokens);

/**
 * Returns the token data stored in the AuthStore
 */
export const useAuthTokenData = () => authStore((state) => state.tokenData);

/**
 * Return the actions to interact with the AuthStore
 */
export const useAuthActions = () => authStore((state) => state.actions);
